import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M13.24 9.078c-.272 1.134-.757.918-.994 1.907a2.609 2.609 0 0 1 1.22-5.073c-.476 1.978.019 2.151-.225 3.166M9.604 9.918c.995.61.639 1.004 1.506 1.536a2.609 2.609 0 0 1-4.447-2.728c1.734 1.064 2.051.646 2.94 1.192M9.28 13.635c.888-.757 1.153-.297 1.927-.958a2.609 2.609 0 0 1-3.969 3.387c1.548-1.32 1.249-1.752 2.042-2.429M12.715 15.092c-.447-1.078.072-1.188-.317-2.128a2.609 2.609 0 0 1 1.996 4.82c-.778-1.88-1.28-1.728-1.68-2.692M15.16 12.274c-1.162.091-1.107-.436-2.12-.357a2.609 2.609 0 0 1 5.2-.408c-2.028.16-2.039.684-3.08.765"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }